import { LoadingIndicator } from 'components/LoadingIndicator';
import { useChain, usePrice } from 'contexts';
import React from 'react';
import { getChainData } from 'utils/chain';
import { formatUsdPrice } from 'utils/price';
import { ChainId, Currency } from 'utils/types';

type Props = {
  chainId: ChainId;
};

const ChainCard: React.FC<Props> = ({ chainId }) => {
  const { id: selectedChainId, setChainId } = useChain();
  const { getChainTokenPrices } = usePrice();
  const { displayName, styleSlug } = getChainData(chainId);
  const selected = chainId === selectedChainId;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setChainId(chainId);
  };

  const surfUsd = getChainTokenPrices(chainId)[Currency.SURF]?.[Currency.USD];

  return (
    <div className="flex flex-col items-center">
      <img src={`/img/chains-filled/${styleSlug}.svg`} className="w-10 h-10 mb-2" alt="" />
      <div
        className={`w-full rounded-xl bg-${styleSlug}-primary bg-gradient-to-l dark:from-${styleSlug}-light dark:to-${styleSlug}-primary`}
        style={{ padding: 2 }}
      >
        <a
          href={`#${styleSlug}`}
          className={`block p-3 pb-2 rounded-10 overflow-hidden ${
            selected
              ? `bg-${styleSlug}-primary bg-gradient-to-b dark:from-${styleSlug}-dark dark:to-gray-111 dark:box-shadow-inset`
              : 'bg-white dark:bg-gray-111'
          } text-center ${
            selected ? 'text-white' : `text-${styleSlug}-primary dark:text-${styleSlug}-light`
          }`}
          onClick={handleClick}
        >
          <span className="block text-2xl">
            {typeof surfUsd !== 'undefined' ? formatUsdPrice(surfUsd) : <LoadingIndicator />}
          </span>
          <span className="block text-11">{displayName.toUpperCase()}</span>
        </a>
      </div>
    </div>
  );
};

export default ChainCard;
